module.exports = __webpack_public_path__ + "img/vaibhav_sir_thumbnail2.44385805.jpg";